import { useQuery } from '@apollo/client';
import { isAdminRole, isAgentRole, isSuperRole } from 'gmd-utilities-package';
import { graphql } from '../__generated__';
import { GmdUserInfo } from '../types';

export const getCurrentAgentQuery = graphql(/* GraphQL */ `
  query CurrentAgent {
    agent {
      id
      tenant
      role
    }
  }
`);

const useGmdUserInfo = () => {
  const { data, loading, error } = useQuery(getCurrentAgentQuery);

  const userInfo: GmdUserInfo = {
    id: data?.agent?.id || '',
    role: data?.agent?.role || '',
    tenant: data?.agent?.tenant || '',
  };

  const hasNonSystemClient =
    userInfo?.tenant && userInfo?.tenant !== 'SystemTenant' ? true : false;

  const role = loading || error ? '' : data?.agent?.role || '';

  const canAddClient = isSuperRole(role);

  const canEditClient = isSuperRole(role) || isAdminRole(role);

  const canAddRates =
    hasNonSystemClient && (isSuperRole(role) || isAdminRole(role));

  const canEditRates = canAddRates;

  const canDeleteRates = canAddRates;

  const canAddAgent =
    hasNonSystemClient && (isSuperRole(role) || isAdminRole(role));

  const canEditAgent = canAddAgent;

  const canDeleteAgent = canAddAgent;

  const canRouteToManualRequests =
    isSuperRole(role) || isAdminRole(role) || isAgentRole(role);

  const canRouteToPlatformClients =
    isSuperRole(role) || isAdminRole(role) || isAgentRole(role);

  const canAddSatelliteAgents =
    hasNonSystemClient &&
    (isSuperRole(role) || isAdminRole(role) || isAgentRole(role));

  const canRouteToSatelliteAgents =
    isSuperRole(role) || isAdminRole(role) || isAgentRole(role);

  const canRevertSatelliteAgentBalance =
    isSuperRole(role) || isAdminRole(role) || isAgentRole(role);

  const canRunAgentReports =
    hasNonSystemClient && (isSuperRole(role) || isAdminRole(role));

  const canRouteToGlobalActions = isSuperRole(role);

  return {
    userInfo,
    canAddClient,
    canEditClient,
    canEditRates,
    canAddRates,
    canDeleteRates,
    canAddAgent,
    canEditAgent,
    canDeleteAgent,
    canRouteToManualRequests,
    canRouteToPlatformClients,
    canAddSatelliteAgents,
    canRouteToSatelliteAgents,
    canRevertSatelliteAgentBalance,
    canRunAgentReports,
    canRouteToGlobalActions,
    hasNonSystemClient,
  };
};

export default useGmdUserInfo;
